import { render, staticRenderFns } from "./SkillsStudentsTable.vue?vue&type=template&id=0acd975b&scoped=true"
import script from "./SkillsStudentsTable.vue?vue&type=script&lang=js"
export * from "./SkillsStudentsTable.vue?vue&type=script&lang=js"
import style0 from "./SkillsStudentsTable.vue?vue&type=style&index=0&id=0acd975b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd975b",
  null
  
)

export default component.exports